import { render, staticRenderFns } from "./LifeHistoryCard.vue?vue&type=template&id=fd91edf0&scoped=true"
import script from "./LifeHistoryCard.vue?vue&type=script&lang=js"
export * from "./LifeHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./LifeHistoryCard.vue?vue&type=style&index=0&id=fd91edf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd91edf0",
  null
  
)

export default component.exports